import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'ArithmeticOperation';

export const ArithmeticOperation = {
  Addition: tagEnum($, 1),
  Subtraction: tagEnum($, 2),
  Multiplication: tagEnum($, 3),
  Division: tagEnum($, 4),
} as const;

export type ArithmeticOperation = TaggedEnumUnion<typeof ArithmeticOperation>;

const ArithmeticOperations = {
  [$tag]: $,
  [ArithmeticOperation.Addition]: {
    value: ArithmeticOperation.Addition,
    slug: 'add',
    label: 'Addition',
    symbol: '+',
    color: 0x7700cc,
  },
  [ArithmeticOperation.Subtraction]: {
    value: ArithmeticOperation.Subtraction,
    slug: 'sub',
    label: 'Subtraction',
    symbol: '-',
    color: 0x00bb66,
  },
  [ArithmeticOperation.Multiplication]: {
    value: ArithmeticOperation.Multiplication,
    slug: 'mul',
    label: 'Multiplication',
    symbol: '×',
    color: 0x0033dd,
  },
  [ArithmeticOperation.Division]: {
    value: ArithmeticOperation.Division,
    slug: 'div',
    label: 'Division',
    symbol: '÷',
    color: 0xee0022,
  },
} as const;

export const $ArithmeticOperation = buildStaticContext(ArithmeticOperations);
export type $ArithmeticOperation = typeof $ArithmeticOperation;
